export default __webpack_public_path__ + "static/juvederm-valentine-1d8d38a6c1fbcc56fc96e71852f3f299.jpg";